import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { LabelProps, TableHeaderProps } from "../../../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import Edit from "../../../../../../images/EditProfile.svg";
import Delete from "../../../../../../images/Delete.svg";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { Label } from "../../../../../../stories/Label/Label";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  getModifiedScrollHeight,
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Button } from "../../../../../../stories/Button/Button";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import {
  AddSupplierMultiLocationResult,
  AddSupplierMultiLocationVar,
  AtsAcLdgrMultiLocation,
  AtsAcLdgrMultiLocationEdge,
  AtsAcLdgrMultiLocationOrderField,
  DeleteSupplierMultiLocationResult,
  DeleteSupplierMultiLocationVar,
  GetSupplierMultiLocationResult,
  GetSupplierMultiLocationVars,
  UpdateSupplierMultiLocationResult,
  UpdateSupplierMultiLocationVar,
} from "../queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GetLocationByNodeId,
  GetSupplierMultiLocation,
} from "../queries/queries";
import {
  debouncedDelay,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { Form, Formik, FormikProps } from "formik";
import {
  MultiLocationForm,
  PredefinedDataTypes,
} from "../../../../../../utils/formTypes";
import { multiLocationValidation } from "../../../../../../utils/validationSchema";
import InputNumber from "../../../../../common/Input/InputNumber";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import InputHoc from "../../../../../common/Input/Index";
import {
  AddSupplierMultiLocation,
  DeleteSupplierMultiLocation,
  UpdateSupplierMultiLocation,
} from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../../../../pages/LoadingModal";
import Navbar from "../../../../../common/layout/Navbar";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useFormJson from "../../../../../../json/useFormJson";
import { useDebounce } from "../../../../../../customHooks/useDebounce";

interface Props {
  pageType: PageFor;
  operation: Operation;

  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  step: number;
}

const MultiLocation = ({ pageType, operation, setModalFlag, step }: Props) => {
  const { Masters_Table } = useAssetTableJson();
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const { multiLocation } = useFormJson();
  const [locations, setLocations] = useState<AtsAcLdgrMultiLocationEdge[]>([]);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);

  const [operationType, setOperationType] = useState(operation);

  const { dispatch, state } = useContext(AppContext);

  const { customer_id, supplier_id } = useUrlParams();
  const [location_id, setLocationId] = useState(0);

  const navigate = useNavigate();

  const initialValues: MultiLocationForm = {
    address: "", // Address
    city: "", // City
    pin: "", // Pin Code
    state: "", // State
    country: "", // Country
    email: "", // Email
    phone: "", // Phone (Mobile)
    gstNo: "", // GST No
    tanNo: "", // TAN No
    vatNo: "", // VAT No
    panNo: "", // PAN No (corrected key)
    contactPerson: "", // Contact Name
    contactPersonAddress: "", // Contact Person Address
    contactPersonCity: "", // Contact Person City
    contactPersonPin: "", // Contact Person Pin
    contactPersonState: "", // Contact Person State
    contactPersonCountry: "", // Contact Person Country
    contactPersonEmail: "", // Contact Person Email
    contactPersonMobile: "", // Contact Person Mobile
    contactPersonAadhar: "", // C
  };

  const [formData, setFormData] = useState<MultiLocationForm>(initialValues);
  const { user_details } = useLoggedInUserDetails();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [message, setMessage] = useState(emptyMessage);

  const [GetLocations, { data, loading, fetchMore }] = useLazyQuery<
    GetSupplierMultiLocationResult,
    GetSupplierMultiLocationVars
  >(GetSupplierMultiLocation);

  const [GetLocationById, { loading: GetLocationByNodeIdLoading }] =
    useLazyQuery<{ node: AtsAcLdgrMultiLocation }, nodeVar>(
      GetLocationByNodeId
    );

  const [AddSupplierDetails, { loading: AddSupplierMultiLocationLoading }] =
    useMutation<AddSupplierMultiLocationResult, AddSupplierMultiLocationVar>(
      AddSupplierMultiLocation,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const [
    UpdateSupplierDetails,
    { loading: UpdateSupplierMultiLocationLoading },
  ] = useMutation<
    UpdateSupplierMultiLocationResult,
    UpdateSupplierMultiLocationVar
  >(UpdateSupplierMultiLocation, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [DeleteSupplier, { loading: DeleteSupplierMultiLocationLoading }] =
    useMutation<
      DeleteSupplierMultiLocationResult,
      DeleteSupplierMultiLocationVar
    >(DeleteSupplierMultiLocation, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });

  const dynamicHeaders: TableHeaderProps[] =
    Masters_Table.Masters.MultipleLocation.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
    }));

  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                fillFormDataForUpdate(params.row.location_id);
              }}
            />
            <img
              src={Delete}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_LOCATION_ID,
                  payload: { locationId: params.row.location_id },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSupplierMultiLocation.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = locations.find(
            (customer) => customer.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setLocations(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            state: node.state,
            addr: node.address,
            gstNo: node.gstNo,
            location_id: node.id,
          }))
        );
      } else {
        setLocations(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            state: node.state,
            addr: node.address,
            gstNo: node.gstNo,
            location_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetSupplierMultiLocation.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [loading, data]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSupplierMultiLocation.edges;
              const pageInfo =
                fetchMoreResult.GetSupplierMultiLocation.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck =
                prevResult.GetSupplierMultiLocation.edges.filter(
                  ({ node: { id } }) =>
                    newEdges.findIndex(
                      ({ node: { id: newId } }) => newId === id
                    ) !== -1
                );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSupplierMultiLocation: {
                  edges: [...locations, ...newEdges],
                  pageInfo,
                  totalCount: data
                    ? data.GetSupplierMultiLocation.totalCount!
                    : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (customer_id && supplier_id) {
      GetLocations({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          name: debouncedSearch,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsAcLdgrMultiLocationOrderField.CREATED_AT,
          },
          supplier_id,
          
        },
      });
    }
  }, [customer_id, supplier_id, GetLocations, debouncedSearch]);

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<MultiLocationForm>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleDelete = async (id: number) => {
    setDeleteModal(!deleteModal);
      DeleteSupplier({
        variables: {
          supplier_multi_loc_id: id,
          
          user_details,
        },
        refetchQueries: [
          {
            query: GetSupplierMultiLocation,
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              name: debouncedSearch,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrMultiLocationOrderField.CREATED_AT,
              },
              supplier_id,
              
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.DeleteSupplierMultiLocation) {
          setMessage({
            flag: true,
            message: "Successfully deleted Location",
            operation: Operation.NONE,
          });
        }
      });
  };

  const handleSubmit = async () => {
    if (customer_id && supplier_id) {
      if (operationType === Operation.CREATE) {
        const empAdded = AddSupplierDetails({
          variables: {
            
            user_details,
            customer_id,
            supplier_id,
            input: {
              address: removeMoreSpace(formData.address),
              city: formData.city,
              pin: formData.pin,
              state: formData.state,
              country: formData.country,
              email: formData.email,
              phone: `+${formData.phone}`,
              gstNo: formData.gstNo,
              tanNo: formData.tanNo,
              vatNo: formData.vatNo,
              panNo: formData.panNo,
              contactPerson: formData.contactPerson,
              contactPersonAddress: formData.contactPersonAddress,
              contactPersonCity: formData.contactPersonCity,
              contactPersonPin: formData.contactPersonPin,
              contactPersonState: formData.state,
              contactPersonCountry: formData.country,
              contactPersonEmail: formData.email,
              contactPersonMobile: `+${formData.contactPersonMobile}`,
              contactPersonAadhar: formData.contactPersonAadhar,
            },
          },
          refetchQueries: [
            {
              query: GetSupplierMultiLocation,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                name: debouncedSearch,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrMultiLocationOrderField.CREATED_AT,
                },
                supplier_id,
                
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddSupplierMultiLocation) {
          setMessage({
            flag: true,
            message: "Location added successfully",
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateSupplierDetails({
          variables: {
            
            user_details,
            supplier_multi_loc_id: location_id,
            input: {
              address: removeMoreSpace(formData.address),
              city: formData.city,

              pin: formData.pin,
              state: formData.state,
              country: formData.country,
              email: formData.email,
              phone: `+${formData.phone}`,
              gstNo: formData.gstNo,
              tanNo: formData.tanNo,
              vatNo: formData.vatNo,
              panNo: formData.panNo,
              contactPerson: formData.contactPerson,
              contactPersonAddress: formData.contactPersonAddress,
              contactPersonCity: formData.contactPersonCity,
              contactPersonPin: formData.contactPersonPin,
              contactPersonState: formData.state,
              contactPersonCountry: formData.country,
              contactPersonEmail: formData.email,
              contactPersonMobile: `+${formData.contactPersonMobile}`,
              contactPersonAadhar: formData.contactPersonAadhar,
            },
          },
          refetchQueries: [
            {
              query: GetSupplierMultiLocation,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                name: debouncedSearch,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrMultiLocationOrderField.CREATED_AT,
                },
                supplier_id,
                
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateSupplierMultiLocation) {
          setMessage({
            flag: true,
            message: "Location updated successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  const handleClear = () => {
    setFormData(initialValues);
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      if (operation === Operation.CREATE) {
        setOperationType(Operation.CREATE);
      }
    }

    setMessage(emptyMessage);
  };

  const fillFormDataForUpdate = async (id: number) => {
    setOperationType(Operation.UPDATE);
      setLocationId(id);
      
        GetLocationById({
          variables: {
            id: id,
            
          },
        }).then(({ data }) => {
          if (data && data.node) {
            setFormData({
              address: data.node.address,
              city: data.node.city,
              contactPerson: data.node.contactPerson,
              contactPersonAadhar: data.node.contactPersonAadhar,
              contactPersonAddress: data.node.contactPersonAddress,
              contactPersonCity: data.node.contactPersonCity,
              contactPersonCountry: data.node.contactPersonCountry,
              contactPersonEmail: data.node.contactPersonEmail,
              contactPersonMobile: data.node.contactPersonMobile,
              contactPersonPin: data.node.contactPersonPin,
              contactPersonState: data.node.contactPersonState,
              country: data.node.country,
              email: data.node.email,
              gstNo: data.node.gstNo,
              panNo: data.node.panNo,
              phone: data.node.phone,
              pin: data.node.pin,
              state: data.node.state,
              tanNo: data.node.tanNo,
              vatNo: data.node.vatNo,
            });
          }
        });
      
  };

  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return (
    <>
      {operation === Operation.CREATE && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
          <div className="multi-location__title">
            <Title>
              {operationType === Operation.CREATE ? "Add" : "Update"} Mutiple
              Location
            </Title>
            {pageType === PageFor.MODAL && (
              <img src={Close} alt="" onClick={() => setModalFlag(false)} />
            )}
          </div>
        </>
      )}
      <Formik
        initialValues={formData}
        validationSchema={multiLocationValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="multi-location">
              <div className="multi-location__block">
                <div className="multi-location__block--left">
                  <Title variant="subtitle1">Add Locations</Title>
                  <div className="multi-location__block--left--details">
                    {multiLocation.map((field: LabelProps, key: React.Key) => {
                      if (field.dataType === "textarea") {
                        return (
                          <React.Fragment key={key}>
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <TextArea
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                rows={3}
                                name={field.inputName}
                              />
                            </div>
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span />
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      } else if (field.dataType === "mobile") {
                        return (
                          <React.Fragment>
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                            </div>
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span />
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      } else if (field.dataType === "number") {
                        return (
                          <React.Fragment key={key}>
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                name={field.inputName}
                                required={field.required}
                                maxLength={field.maxLength}
                              />
                            </div>
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span />
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      } else if (field.dataType === "city") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  city: e,
                                });
                              }}
                              type={PredefinedDataTypes.CITY}
                              value={formData.city as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "state") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e, state_code) => {
                                setFormData({
                                  ...formData,
                                  state: e,
                                  // gstStateCode: state_code
                                  //   ? state_code
                                  //   : EMPTY_STRING,
                                });
                              }}
                              type={PredefinedDataTypes.STATE}
                              value={formData.state as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "country") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  country: e,
                                });
                              }}
                              type={PredefinedDataTypes.COUNTRY}
                              value={formData.country as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else {
                        return (
                          <React.Fragment key={key}>
                            <InputHoc
                              LabelName={field.labelName}
                              values={formData[field.inputName]}
                              name={field.inputName}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              required={field.required}
                              autoFocus={field.autoFocus}
                            />
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span />
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    })}
                  </div>
                </div>
                <div className="multi-location__block--right">
                  <Title variant="subtitle1">List of Locations</Title>
                  <div className="multi-location__block--table">
                    <StyledDatagrid
                      columns={columns}
                      rows={rows}
                      rowHeight={TABLE_ROW_HEIGHT}
                      disableRowSelectionOnClick
                      hideFooter
                    />
                  </div>
                </div>
              </div>
              <Button mode="save" type="submit" />
              <Button mode="clear" type="button" onClick={handleClear} />
              <Button
                mode={pageType === PageFor.GENERAL ? "back" : "cancel"}
                type="button"
                onClick={() => {
                  if (pageType === PageFor.GENERAL) {
                    navigate(-1);
                  } else setModalFlag(false);
                }}
              />
            </Form>
          );
        }}
      </Formik>

      <DeleteModal
        id={state.locationId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetLocationByNodeIdLoading ||
          AddSupplierMultiLocationLoading ||
          UpdateSupplierMultiLocationLoading ||
          DeleteSupplierMultiLocationLoading
        }
      />
    </>
  );
};

export default MultiLocation;
